export const LANGUAGE_OPTIONS = [
  { urlLocale: 'en_US', value: 'en-US', label: 'English' },
  { urlLocale: 'fr_FR', value: 'fr', label: 'French (Français)' },
  { urlLocale: 'de_DE', value: 'de', label: 'German (Deutsch)' },
  { urlLocale: 'it_IT', value: 'it', label: 'Italian (Italiano)' },
  { urlLocale: 'es_ES', value: 'es-ES', label: 'Spanish (Español)' },
  { urlLocale: 'pt_BR', value: 'pt-PT', label: 'Portuguese (português)' },
];

export const getLanguageByUrlLocale = (urlLocale) => LANGUAGE_OPTIONS.find((langObj) => langObj.urlLocale === urlLocale)?.value || 'en-US';

export const getLanguage = () => window.localStorage.getItem('lang') || 'en-US';

export const setLanguage = (lang = 'en-US') =>  {
  window.localStorage.setItem('lang', lang);
  window.localStorage.setItem('auth_lang', lang);
};
